module.exports = __webpack_public_path__ + "img/slack.26801d2b.svg";